/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import $ from 'jquery';
import Vue from 'vue';

import DropdownPresenter from '@/components/presenters/DropdownPresenter.vue';

export default function initDropdownPresenters() {
  const toBool = value => value ? true : false;

  $('dropdown-presenter').each(function () {
    const props = {...this.dataset};
    if (props.options) {
      props.options = JSON.parse(props.options);
    }
    if (props.selectedOption) {
      props.selectedOption = JSON.parse(props.selectedOption);
    }
    props.multiple = toBool(props.multiple);
    props.required = toBool(props.required);
    props.taggable = toBool(props.taggable);

    new Vue({
      el: this,
      render: html => html(DropdownPresenter, {props}),
    });
  });
};
